/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'doT',
	'text!./templates/DashboardColorSet.html',
	'./ColorUtils'
], (_, dot, templateString, ColorUtils) => {
	class DashboardColorSet {
		static getColorStyles(colorService, paletteId) {
			/* color: {{=it.foregroundColors[color.name].value}};
			Apply the foreground color when the widget has a fill color
			or when the fill color is transparent and the parent has a color
			We also apply the foreground color to svg text
			Primary foreground color
			*/
			return colorService.getForegroundCSSColors('ForegroundUserPaletteColor', paletteId).then((foregroundColors) => {

				const mainColors = colorService.getColorSet(paletteId);
				const gridColors = [];
				const dataPlayerColors= [];
				const kpiValueColors = _.clone(foregroundColors, true);
				const kpiLabelColors = _.clone(foregroundColors, true);
				kpiValueColors['color1'] = 'rgba(52, 51, 52, 1)';
				kpiLabelColors['color1'] = 'rgba(89, 88, 89, 1)';
				if (colorService.getValueForPropertyOfUIElement('board', 'backgroundColor') === '#FFFFFF') {
					kpiValueColors['transparent'] = 'rgba(52, 51, 52, 1)';
					kpiLabelColors['transparent'] = 'rgba(89, 88, 89, 1)';
				}
				mainColors.forEach((color) =>{
					let hexValue = color.hexValue;
					if (color.name === 'transparent') {
						hexValue = colorService.getValueForPropertyOfUIElement('board', 'backgroundColor');
					}

					gridColors[color.name] = ColorUtils.invertColor(hexValue, 120, 100, true);
					dataPlayerColors[color.name] = ColorUtils.invertColor(hexValue, 120, 100, false);

				});

				return DashboardColorSet.dotTemplate({
					colors: mainColors,
					foregroundColors: foregroundColors,
					kpiValueColors: kpiValueColors,
					kpiLabelColors: kpiLabelColors,
					gridColors: gridColors,
					dataPlayerColors: dataPlayerColors
				});
			});
		}
	}

	DashboardColorSet.dotTemplate = dot.template(templateString);

	return DashboardColorSet;
});
